module.exports = __webpack_public_path__ + "static/SummerHearts-Regular.8b078516.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SummerHearts-Regular.otf
// module id = 325
// module chunks = 168707334958949